import { render } from "./dates-table.vue?vue&type=template&id=11f4d297&lang=pug"
import script from "./dates-table.vue?vue&type=script&lang=js"
export * from "./dates-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__